const recentSkillsOption = ({skills_completed_since_last_roundup, ordering, instrument}) => {

  let first_skill;
  let second_skill;
  let third_skill;
  let fourth_skill;
  let title;

  if (skills_completed_since_last_roundup && skills_completed_since_last_roundup.length > 0) {
    first_skill = skills_completed_since_last_roundup[0] ? skills_completed_since_last_roundup[0] : '';
    second_skill = skills_completed_since_last_roundup[1] ? skills_completed_since_last_roundup[1] : '';
    third_skill = skills_completed_since_last_roundup[2] ? skills_completed_since_last_roundup[2] : '';
    fourth_skill = null;
    title = 'Learned this term!';
  } else {
    first_skill = 'Instrument';
    second_skill = 'Song';
    third_skill = 'Musicianship';
    fourth_skill = 'Band';
    title = 'Learned every lesson!';
  }

  const recentSkillData = {
    "order": ordering.skills_completed_since_last_roundup,
    "name": "skills_completed_since_last_roundup",
    "tracking": "skills_completed_since_last_roundup",
    "colorOption": 1,
    "dataPoints": {
      first_skill,
      second_skill,
      third_skill,
      fourth_skill,
      title,
      instrument
    }
  };
  return recentSkillData;
}

export default recentSkillsOption;

